export default __webpack_public_path__ + "static/media/shovel.c4fb028e.png";